import AddBookForm from './AddBookForm';
import BooksLit from './BooksList';

const BooksContainer = () => (
  <>
    <BooksLit />
    <AddBookForm />
  </>
);

export default BooksContainer;
